<script>
/**
 * Abstract component to be used for any component that uses the Media Picker
 * to assign assets.
 * 
 */

export default {
   data() {
      return {
         activeId: 0, //the ID of the slot/zone we are assigning to
         activeType: Array | String, //the type of the slot/zone we are assigning to
         activeCurrentAssetId: -1, //the ID of the currently assigned asset,
         showMP: false
      }
   },

   mounted() {
      let self = this;
      // EventBus.$on('assign-asset',  function(asset, assetType) { //assign an asset to a zone
      //    self.handleAssignAsset(asset, assetType);
      // });

      this.$on('OpenMediaPicker', function(assetType, assetId, activeAssetId) {
         self.activeId = assetId;
         self.activeType = assetType;
         self.activeCurrentAssetId = activeAssetId;
         self.showMP = true;
      });
   },

   methods: {
      handleAssignAsset(asset, assetType) {
         //implemented by children
         console.log('You need to implement this method in the child.');
      },

      catchAssignAssetEvent() {
         
      }
   }
}
</script>